import { InputEventDetails } from "@/types/types";
import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";

@customElement("login-page")
export class LoginPage extends LitElement {
	static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      gap: 2rem;
      padding: 1rem;
    }

    .form {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
      width: 300px;
      max-width: 90%;
    }

    .error {
      color: red;
      text-align: center;
    }
  `;

	@state() private username = "";
	@state() private password = "";
	@state() private error: string | null = null;

	constructor() {
		super();
		this.addEventListener("input-change", this._handleInputChange as EventListener);
	}

	private _handleInputChange(event: CustomEvent<InputEventDetails>) {
		if (event.detail.name === "username") {
			this.username = event.detail.value;
		}
		if (event.detail.name === "password") {
			this.password = event.detail.value;
		}
	}

	private async handleLogin() {
		this.error = null;
		const res = await fetch("/api/auth/login/", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			credentials: "include",
			body: JSON.stringify({ username: this.username, password: this.password }),
		});

		if (res.ok) {
			const from = history.state?.from || "/host/events";
			window.history.pushState({}, "", from);
			window.dispatchEvent(new PopStateEvent("popstate"));
		} else {
			const data = await res.json().catch(() => ({}));
			this.error = data.error || "Login failed";
		}
	}

	render() {
		return html`
      ${this.error ? html`<div class="error">${this.error}</div>` : ""}

      <div class="form">
        <basic-input
          label="Username"
          name="username"
          value=${this.username}
        ></basic-input>

        <basic-input
          label="Password"
          name="password"
		  type="password"
          value=${this.password}
        ></basic-input>

        <basic-button @click=${this.handleLogin}>Login</basic-button>
      </div>
    `;
	}
}

export default LoginPage;
